export default __webpack_public_path__ + "c8bcfdd7897d52a4b1554e31019e888c.png";